import { takeEvery, fork, put, all, call, select } from 'redux-saga/effects';

import { GET_MEDIA } from './actionTypes';
import {
    getMediaSuccess,
    getMediaFailed
} from './actions';
import {noParamGet} from '../../../apiHelpers/commonApiHelper';
import toastr from 'toastr';

function* getMedia() {
    try {
        const response = yield call(noParamGet, '/api/v1/campaigns');
        if(response.status === 200) {
            yield put(getMediaSuccess(JSON.parse(response.data.media)));
        } else {
            yield put(getMediaFailed());
        }

    } catch (error) {
        yield put(getMediaFailed());
    }
}


export function* watchGetMedia() {
    yield takeEvery(GET_MEDIA, getMedia)
}

function* campaignSaga() {
    yield all([
        fork(watchGetMedia)
    ]);
}

export default campaignSaga;